import PaymentStatus from '../types/paymentStatus.type';
import { paymentStatusNames } from './paymentStatus.utils';

export const INVOICE_STATUS_NAMES: Record<string, string> = {
  ...paymentStatusNames,
  [PaymentStatus.REJECTED]: 'Canceled',
};

export const REQUEST_STATUS_NAMES: Record<string, string> = {
  ...paymentStatusNames,
};
